import { useState, type ReactNode } from 'react'

interface AccordionSectionProps {
  title: string
  defaultOpen?: boolean
  badge?: string
  children: ReactNode
}

/**
 * Self-contained collapsible section (own React state, not Bootstrap's JS
 * collapse) so the Candidate Search v2 filter form's many sections don't
 * fight React's reconciliation the way a Bootstrap data-bs-toggle
 * collapse mutating classes outside React sometimes can. Styled to match
 * Bootstrap's accordion look regardless.
 */
export function AccordionSection({ title, defaultOpen = false, badge, children }: AccordionSectionProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          type="button"
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <span className="d-flex align-items-center gap-2">
            {title}
            {badge && <span className="badge bg-primary-transparent fs-11">{badge}</span>}
          </span>
        </button>
      </h2>
      {open && (
        <div className="accordion-collapse">
          <div className="accordion-body">{children}</div>
        </div>
      )}
    </div>
  )
}
